<template>
  <mdb-modal removeBackdrop size="md" :show="modalShow" @close="handleClose">
    <mdb-modal-header class="text-center" color="indigo">
      <mdb-modal-title tag="h4" bold class="w-100 text-white">{{
        $t("edit")
      }}</mdb-modal-title>
    </mdb-modal-header>
    <mdb-modal-body class="mx-3" color="white">
      <mdb-input
        :label="$t('subcategory_name')"
        type="text"
        v-model="subCategoryName"
      />
      <mdb-input
        :label="$t('subcategory_description')"
        type="textarea"
        v-model="subCategoryDescription"
      />
      <mdb-input
        :label="$t('subcategory_url')"
        type="textarea"
        v-model="subCategoryUrl"
      />
      <mdb-select
        search
        v-on:getValue="getSelectedValue"
        v-model="labelOptions"
        :visibleOptions="6"
        :label="$t('retailerchain')"
        :placeholder="$t('choose_retailerchain')"
      />
    </mdb-modal-body>
    <mdb-modal-footer center>
      <mdb-btn @click="saveEditSubCategory" color="indigo"
        >{{ $t("save") }}<mdb-icon icon="paper-plane" class="ml-1"
      /></mdb-btn>
    </mdb-modal-footer>
  </mdb-modal>
</template>

<script>
import {
  mdbBtn,
  mdbModal,
  mdbModalHeader,
  mdbModalBody,
  mdbInput,
  mdbModalFooter,
  mdbModalTitle,
  mdbIcon,
  mdbSelect,
} from "mdbvue";
export default {
  name: "EditSubCategory",
  props: {
    modalShow: Boolean,
    addSubCategoryState: Boolean,
    name: String,
    visible: Number,
    description: String,
    id: Number,
    url: String,
    categoryid: Number,
    subcategorytypeid: Number,
    subcategorytypename: String,
    subcategorytypes: Array,
  },
  components: {
    mdbBtn,
    mdbModal,
    mdbModalHeader,
    mdbModalBody,
    mdbInput,
    mdbModalFooter,
    mdbModalTitle,
    mdbIcon,
    mdbSelect,
  },
  mounted() {
    this.labelOptions = this.subcategorytypes.map((type) => {
      return {
        text: type.name,
        value: type.id,
        selected: type.id === this.subcategorytypeid,
      };
    });
    this.loadReady = true;
  },
  data() {
    return {
      subCategoryPath: "/1.0/front/subcategories",
      subCategoryName: this.name,
      subCategoryDescription: this.description,
      subCategoryUrl: this.url,
      loadReady: false,
      labelOptions: [],
    };
  },
  methods: {
    getSelectedValue(value, text) {
      this.subcategorytypeid = value;
      this.subCategoryTypeName = text;
    },
    handleClose() {
      console.log("modal hide");
      this.$emit("modal-cancelled");
    },
    saveEditSubCategory() {
      this.postdata = JSON.stringify({
        sessionid: this.$store.getters.getToken,
        name: this.subCategoryName,
        description: this.subCategoryDescription,
        url: this.subCategoryUrl,
        id: this.id,
        category_id: this.categoryid,
        subcategorytype_id: this.subcategorytypeid,
      });
      this.$http
        .post(this.subCategoryPath, this.postdata)
        .then((response) => {
          if (response.status == 200) {
            this.$notify.success({
              message: this.$t("adding_subcategory_success"),
              position: "top right",
              timeOut: this.$store.state.notifytimeoutshort,
            });
          }
          this.$emit("modal-ok");
        })
        .catch((error) => {
          this.$notify.error({
            message: this.$t("adding_subcategory_not_success"),
            position: "top right",
            timeOut: this.$store.state.notifytimeoutshort,
          });
          this.$emit("modal-ok");
          console.log(error);
        })
        .finally(() => (this.loading = false));
    },
  },
};
</script>

<style scoped></style>